export const getGridRowWidthValue = (value): { width: number } | { minWidth: string } =>
	Number.isInteger(value) ? { minWidth: `${value}px` } : { width: value }
